
       function cookieinfobox (options) {
            var defaults = {
              text: '<p>' + jstr_cookieinf + ' <a style="color:lightgreen;" href="' + jstr_cookiehdl + '" title="" onclick="window.open(this.href); return false;">' + jstr_cookielnk + '</a>, <a href="' + jstr_cookiehdl1 + '"  style="color:lightgreen;" title="" onclick="window.open(this.href); return false;">' + jstr_cookielnk1 + '</a></p>',
                close: ' OK ',
                parent: $('body'),
                show_close: true,
                position: 'top',
                cookie_name: 'is-cookies-accepted',
                auto_accept: false,
                box_class: '',
                use_default_css: true,
                box_css: '',
                inner_css: '',
                text_css: '',
                close_css: '',
                animation: 'slide',
                time: 500,
                test: false };
         
         
            var o = $.extend(defaults, options);
            if (o.use_default_css == true) {
              o.box_css = 'line-height: 1.2em; padding: 10px; width: 100%; bottom:0px; position: fixed; z-index: 999; overflow: hidden; background-color: #444; color: #ddd; font-size: 12px; line-height: 120%;' + o.box_css;
                o.inner_css = 'position: relative; padding: 2px 10px;' + o.inner_css;
              o.text_css = 'font-size:13px; padding-right: 26px;' + o.text_css;
                o.close_css = 'position: absolute; top: 0; right: 0; padding: 5px 10px; display: block; background-color: #888; color: #fff; text-transform: uppercase; text-decoration: none;' + o.close_css
            }
            $('#cookieinfobox-box').remove();
            var box = $('<div id="cookieinfobox-box" class="' + o.box_class + '" style="' + o.box_css + '"><div class="cookieinfobox-inner" style="' + o.inner_css + '">' + '<div class="cookieinfobox-text" style="' + o.text_css + '">' + o.text + '</div>' + '</div></div>');
            if (o.show_close == true) box.find('.cookieinfobox-inner').append('<a href="#" class="cookieinfobox-close" style="' + o.close_css + '">' + o.close + '</a>');
            if (readCookie(o.cookie_name) == null) {
                if (o.position == 'top') o.parent.prepend(box);
                else if (o.position == 'bottom') o.parent.append(box);
                else o.parent.append(box); if (!o.test && o.auto_accept) createCookie(o.cookie_name, 1, 365)
            };
            box.find('a.cookieinfobox-close').click(function (e) {
                e.preventDefault();
                if (!o.test && !o.auto_accept) createCookie(o.cookie_name, 1, 365);
                if (o.animation == 'slide') box.slideUp(o.time);
                else if (o.animation == 'fade') box.fadeOut(o.time);
                else box.hide()
            });

        }



            function createCookie(name, value, days) {
                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    var expires = "; expires=" + date.toGMTString()
                } else var expires = "";
                document.cookie = name + "=" + value + expires + "; path=/"
            };

            function readCookie(name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
                }
                return null
            }
